import React from 'react'
import { useThemedColours } from 'hooks/useTheme'

interface FlagProps {
  text: string
  color: string
}

const Flag: React.FC<FlagProps> = ({ text, color }) => {
  const themed = useThemedColours()
  return (
    <div
      className="flex items-center justify-center text-xs h-full box-border font-bold relative text-center ml-[5px] h-5 text-on-solid rounded-[5px] py-px px-[7px] top-[-1px]"
      style={{ backgroundColor: themed.fill(color) }}
    >
      {text}
    </div>
  )
}

export default Flag
